import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { AuthService } from "../../shared/services/auth.service";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class UserConfigService {

  constructor(private http: HttpClient, private authService: AuthService) { }

  addUser(user: any): Observable<any> {
    return this.http.post(`${environment.apiUrl}/users`, user);
  }

  getUsers(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/users`);
  }

  toggleUserActive(email: string, active: boolean) {
    return this.http.put(`${environment.apiUrl}/users/active`, {
      email,
      active
    });
  }

  resetPassword(email: string): Observable<any> {
    return this.http.put(`${environment.apiUrl}/users/reset`, { email });
  }
}
